export const DEFAULT_IPFS_GATEWAY = 'https://ipfs.gateway.fatsale.org/ipfs/'
export const nftMetadataCache = new Map()

export function normalizeNftUri(value, gateway = DEFAULT_IPFS_GATEWAY) {
    const uri = String(value || '').trim()
    if (!uri) return ''
    if (uri.startsWith('ipfs://')) {
        return `${gateway}${uri.slice(7).replace(/^ipfs\//, '')}`
    }
    if (/^https?:\/\//i.test(uri)) return uri
    if (/^data:image\/(?:png|jpe?g|gif|webp|svg\+xml)[;,]/i.test(uri)) return uri
    return ''
}

function decodeBase64(value) {
    const binary = window.atob(value)
    const escaped = Array.from(binary, (char) => `%${char.charCodeAt(0).toString(16).padStart(2, '0')}`).join('')
    try {
        return decodeURIComponent(escaped)
    } catch (_error) {
        return binary
    }
}

export function readInlineMetadata(uri) {
    const match = String(uri || '').match(/^data:application\/json(?:;charset=[^;,]+)?(;base64)?,(.*)$/i)
    if (!match) return null

    try {
        const json = match[1] ? decodeBase64(match[2]) : decodeURIComponent(match[2])
        const payload = JSON.parse(json)
        return payload && typeof payload === 'object' && !Array.isArray(payload) ? payload : null
    } catch (_error) {
        return null
    }
}

export function shapeNftMetadata({ tokenId, payload }) {
    const id = String(tokenId)
    const validPayload = payload && typeof payload === 'object' && !Array.isArray(payload)
    return {
        id,
        name: validPayload && String(payload.name || '').trim() ? String(payload.name).trim() : `NFT #${id}`,
        image: validPayload ? normalizeNftUri(payload.image) : '',
        description: validPayload ? String(payload.description || '') : '',
        metadataStatus: validPayload ? 'ready' : 'error',
    }
}

export async function mapWithConcurrency(items, limit, worker) {
    const source = Array.from(items || [])
    if (source.length === 0) return []

    const concurrency = Math.max(1, Math.min(source.length, Number(limit) || 1))
    const results = new Array(source.length)
    let nextIndex = 0

    const run = async () => {
        while (nextIndex < source.length) {
            const index = nextIndex
            nextIndex += 1
            results[index] = await worker(source[index], index)
        }
    }

    await Promise.all(Array.from({ length: concurrency }, run))
    return results
}
